import { ContainerId } from "./drawer";

/** Models the container information stored in Firestore */
export class Container {
  id: ContainerId;

  /**
   * The id of the medication currently in the container
   * This should be undefined if the container is empty
   */
  medicationId?: string;

  /**
   * How much of the medication is in the container
   * An undefined value is allowed
   * This should correspond to the units of ProviderOrder.quantity
   */
  quantity?: number;

  constructor(id?: string, medicationId?: string, quantity?: number) {
    this.id = Number.parseInt(id ?? '0') as ContainerId;
    this.medicationId = medicationId ? medicationId : undefined;
    this.quantity = quantity;
  }
}
